import OadpPagination from './oadp-pagination';
export default OadpPagination;
